import { WearableDataWidget } from "@/components/patient/WearableDataWidget";

export const PatientWearableDataPage = () => {
  return (
    <div className="p-4 md:p-6 space-y-6 max-w-4xl mx-auto">
      {/* Header */}
      <div>
        <h1 className="text-2xl md:text-3xl font-bold">Dati Salute</h1>
        <p className="text-muted-foreground">Monitora i tuoi parametri vitali dal tuo wearable</p>
      </div>

      {/* Full Widget */}
      <WearableDataWidget />
    </div>
  );
};

export default PatientWearableDataPage;
